module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Engagement Imagineer.8726e92a.png";